import { formatDateTimeRange } from '../utils/misc';
import './DateTimeBadge.scss';

export default function DateTimeBadge({ start, end }) {
  return (
    <div className='date-time-badge badge'>
      <span className='fa-clock' />
      {formatDateTimeRange(start, end)}
    </div>
  );
}
